import React from 'react'
import PropTypes from 'prop-types'
import { useAppContext } from '../../../redux/slices/appContext'
import { useClientThings } from '../../../api/things'
import { ThingContext } from './ThingContext'

function ThingProvider ({ children }) {
  const { clientId } = useAppContext()
  const things = useClientThings(clientId)

  return (
    <ThingContext.Provider value={things}>
      {children}
    </ThingContext.Provider>
  )
}

ThingProvider.propTypes = {
  children: PropTypes.node
}

export default ThingProvider
